<script setup lang="ts">
export interface CiSuccessProps {
  message: string;
}
const props = withDefaults(defineProps<CiSuccessProps>(), {});

const { $gettext } = useGettext();
</script>

<template>
  <div class="grid grid-cols-12">
    <div class="col-span-4 col-start-5 md:col-span-4 lg:col-span-2 lg:col-start-6">
      <div class="mx-auto my-0 h-auto w-[90px]">
        <CiAnimatedCheck />
      </div>
    </div>
    <div class="col-span-12 mt-6 text-center">
      <h3>
        <span>{{ $gettext('Thank you.') }}</span>
      </h3>
      <p>{{ props.message }}</p>
    </div>
  </div>
</template>
